import { render, staticRenderFns } from "./billsettings.vue?vue&type=template&id=fef85fa0&scoped=true"
import script from "./billsettings.vue?vue&type=script&lang=js"
export * from "./billsettings.vue?vue&type=script&lang=js"
import style0 from "./billsettings.vue?vue&type=style&index=0&id=fef85fa0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef85fa0",
  null
  
)

export default component.exports